import React from 'react';

import ReactDOM from "react-dom";
// @ts-ignore
import {GeneralAssetUrl} from '../../themes/kent/utilities/constants';
/**
 *
 * Portal Modal component
 * @extends {React.Component}
 */
interface IProps {
 positionType?: string;
 theme?:string;
 content?:any;
 hideCloseButton?:boolean;
 modalActive?:boolean;
 frame?:boolean;
 modalHidden?:any;
}

interface IState {
  modalActive:boolean;
	hideModal:boolean;
  modalId?:any;
}

class PortalModal extends React.Component<IProps,IState>{

  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = ({
      modalActive:false,
      hideModal:false
    })
  }

	public componentDidMount = () =>{
    	if(this.props.modalActive){
			this.setupModal()
		}
	}
  componentDidUpdate = ()=>{
    if(this.props.modalActive && !this.state.modalActive){
			this.setupModal()
		}
  }
  setupModal = ()=>{
    let modalId = Math.floor(Math.random() * 1000);
    let elem = document.createElement('div');
    elem.setAttribute('id',"modal-root-"+modalId);
    document.body.appendChild(elem);
    this.setState({
      modalActive:true,
      modalId:modalId
    })
  }
	public hideModal = () =>{
		this.setState({
			hideModal:true
		})
		setTimeout(() => {
      if(this.props.modalHidden){
        this.props.modalHidden()
      }
			this.setState({
				modalActive:false,
				hideModal:false
			})
		},500)
	}
	public render(): JSX.Element {
		const {frame, theme,positionType,content,hideCloseButton} = this.props;
		let position:any = "fixed";
		if(positionType == "absolute"){
			position = "absolute";
		}
		let animateOut:any = "";
		if(this.state.hideModal){
			animateOut = "animate-out"
		}

		let closeImage:any = GeneralAssetUrl+"close-white.png";
		let componentTheme:any = "dark-theme";
		if(theme == "light"){
			closeImage = GeneralAssetUrl+"close-black.png";
			componentTheme = "light-theme";
		}

		if(!this.state.modalActive) return <span />
    let portal:any = document.getElementById('modal-root-'+this.state.modalId);
    return ReactDOM.createPortal(
			<div className="portal-modal">
 			 <div className={"modal-background"+" "+animateOut+" "+componentTheme} style={{position:position}}>
			 	 {!hideCloseButton && <img className="portal-modal-close-icon" onClick={this.hideModal} src={closeImage} />}
         {frame ? <div className="small-max-width-container"></div> : content}
 			 </div>
 		 </div>,
		 portal
	 );
	}
}


export default PortalModal;
